// extracted by mini-css-extract-plugin
module.exports = {"errorTemplate":"error_errorTemplate___a1df","title":"error_title__6KJdl","message":"error_message__AvpmF","btnRetry":"error_btnRetry__JhWDP"};